export default __webpack_public_path__ + "static/media/welcome-mb-poster.492f22ef.png";